import { useState, useEffect, useMemo } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import './Routes.css';
import api from '../../services/api';
import { Dropdown } from 'primereact/dropdown';
import { BORDER_STATES, BORDER_CITIES_BY_STATE, BORDER_OPTIONS } from '../../constants/constants';
import { InputText } from 'primereact/inputtext';
import { Card } from 'primereact/card';
import { Badge } from 'primereact/badge';
import { ProgressBar } from 'primereact/progressbar';

export default function EntryPages() {
    const [entryPages, setEntryPages] = useState([]);

    // const [entryPagesFiltered, setEntryPagesFiltered] = useState([]);

    const [loadingPages, setLoadingPages] = useState(true);
    const [selectedPort, setSelectedPort] = useState(null);

    const [borderCountryFiltered, setBorderCountryFiltered] = useState(BORDER_OPTIONS);
    const [borderStatesFiltered, setBorderStatesFiltered] = useState(BORDER_STATES);
    const [borderCitiesFiltered, setBorderCitiesFiltered] = useState('');
    const [filteredCity, setFilteredCity] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    const public_url = process.env.REACT_APP_BORDERGARITA_PUBLIC_APP_URL || '';

    useEffect(() => {
        api.get('/entry_pages/summary')
            .then(response => {
                setBorderCitiesFiltered([]);
                setEntryPages(response.data);
                // setEntryPagesFiltered(response.data);
                setLoadingPages(false);
            })
            .catch(error => {
                console.error('Error fetching port pages:', error);
                setLoadingPages(false);
                if (error.response?.status === 401) {
                    console.log('session expired...');
                }
            });
    }, []);

    const navigate = useNavigate();

    // const lastSyncBodyTemplate = (rowData) => formatDate(rowData.lastSync);

    useEffect(() => {
        if (borderStatesFiltered) {
            const cities = BORDER_CITIES_BY_STATE[borderStatesFiltered] || [];
            setBorderCitiesFiltered(cities);
        } else {
            setBorderCitiesFiltered([]);
        }
    }, [borderStatesFiltered]);

    const entryPagesFiltered = useMemo(() => {
        // console.log('Filtering pages...', { entryPages, borderStatesFiltered, filteredCity });
        if (entryPages.length === 0) return [];

        let filtered = [...entryPages];

        if (searchTerm && searchTerm.trim() !== '') {
            filtered = filtered.filter(page => {
                return (
                    (page.title && page.title.toLowerCase().includes(searchTerm.toLowerCase())) ||
                    (page.h1 && page.h1.toLowerCase().includes(searchTerm.toLowerCase())) ||
                    (page.h2 && page.h2.toLowerCase().includes(searchTerm.toLowerCase())) ||
                    (page.full_slug && page.full_slug.toLowerCase().includes(searchTerm.toLowerCase()))
                );
            });
        } else {
            if (typeof borderCountryFiltered === 'string' && borderCountryFiltered.trim() !== '') {
                console.log('Filtering by country...', borderCountryFiltered);
                filtered = entryPages.filter(page => page.departure.border === borderCountryFiltered);
            }

            if (typeof borderStatesFiltered === 'string' && borderStatesFiltered.trim() !== '') {
                filtered = entryPages.filter(page => page.departure.state === borderStatesFiltered);
            }

            if (filteredCity) {
                filtered = entryPages.filter(page => page.departure.city === filteredCity);
            }
        }

        return filtered;
    }, [entryPages, borderCountryFiltered, borderStatesFiltered, filteredCity, searchTerm]);

    return (
        <Card>
            <div className="card p-4">
                <div className="grid mb-4">
                    <div className="col-6 flex align-items-center">
                        <h2 className="m-0 main-text font-bold vertical-align-middle">
                            <span>Entry pages</span>
                            <Badge className='ml-2 b-4 relative' value={entryPagesFiltered.length ?? 0} style={{ bottom: '3px', backgroundColor: '#2020A0' }} />
                        </h2>
                    </div>
                    <div className="col-6 flex justify-content-end">
                        <Button
                            label="Add entry page"
                            icon="pi pi-plus"
                            className="p-button-primary p-button-sm secondary-button"
                            style={{ minWidth: 120 }}
                            onClick={() => {
                                navigate('/entry_page/new');
                            }}
                        />
                    </div>
                </div>
                <div className='grid mb-4'>
                    <div className="col-12 flex justify-content-between align-items-end">
                        <div className="flex gap-2">
                            <span className="" style={{ minWidth: 180 }}>
                                <label style={{ fontSize: '0.95rem' }}>
                                    <strong style={{ fontSize: '0.95rem' }}>Departure Country</strong>
                                </label>
                                <Dropdown
                                    value={borderCountryFiltered}
                                    options={BORDER_OPTIONS}
                                    showClear
                                    onChange={(e) => setBorderCountryFiltered(e.value)}
                                    filter
                                    filterInputAutoFocus
                                    filterBy="name"
                                    optionLabel="name"
                                    optionValue="code"
                                    placeholder="Select a border country"
                                    className="w-full"
                                />
                            </span>
                            <span className="" style={{ minWidth: 180 }}>
                                <label style={{ fontSize: '0.95rem' }}>
                                    <strong style={{ fontSize: '0.95rem' }}>Departure State</strong>
                                </label>
                                <Dropdown
                                    value={borderStatesFiltered}
                                    options={BORDER_STATES}
                                    showClear
                                    onChange={(e) => setBorderStatesFiltered(e.value)}
                                    filter
                                    filterInputAutoFocus
                                    filterBy="name"
                                    optionLabel="name"
                                    optionValue="code"
                                    placeholder="Select a state"
                                    className="w-full"
                                />
                            </span>
                            <span className="" style={{ minWidth: 180 }}>
                                <label style={{ fontSize: '0.95rem' }}>
                                    <strong style={{ fontSize: '0.95rem' }}>Departure city</strong>
                                </label>
                                <Dropdown
                                    showClear
                                    value={filteredCity}
                                    options={borderCitiesFiltered}
                                    onChange={(e) => setFilteredCity(e.value)}
                                    filter
                                    filterInputAutoFocus
                                    filterBy="name"
                                    optionLabel="name"
                                    optionValue="code"
                                    placeholder="Select a city"
                                    className="w-full"
                                />
                            </span>
                            <div className='flex flex-column' style={{ minWidth: 250 }}>
                                <label style={{ fontSize: '0.95rem' }}>
                                    <strong style={{ fontSize: '0.95rem' }}>Search</strong>
                                </label>
                                <InputText
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="w-full p-button-sm"
                                    placeholder="Search by URL"
                                    style={{ fontSize: '0.95rem' }}
                                />
                            </div>
                            <div className='flex'>
                                <Button
                                    label="Clear search"
                                    icon="pi pi-times"
                                    className="p-button-text text-danger p-button-sm mt-2"
                                    onClick={() => {
                                        setBorderCountryFiltered(BORDER_OPTIONS);
                                        setBorderStatesFiltered(BORDER_STATES);
                                        setBorderCitiesFiltered([]);
                                        setFilteredCity(null);
                                        setSearchTerm('')
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {loadingPages &&
                    <div className="flex flex-column align-items-center justify-content-center" style={{ minHeight: '300px' }}>
                        <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem', color: '#2020A0' }} />
                        <div style={{ marginTop: '1rem', fontSize: '1.2rem', color: '#555' }}>Loading entry pages...</div>
                    </div>}

                <DataTable
                    value={entryPagesFiltered}
                    emptyMessage="No pages found."
                    className="p-datatable-sm"
                    selection={selectedPort}
                    showGridlines
                    stripedRows
                    onSelectionChange={(e) => setSelectedPort(e.value)}
                >
                    <Column field="url" header="URL" headerStyle={{ textAlign: 'center' }}
                        body={(rowData) => (
                            <strong>

                                <a
                                    href={`${public_url}${rowData.full_slug}`}
                                    target="_blank"
                                    title={`${public_url}${rowData.full_slug}`}
                                    rel="noopener noreferrer">
                                    {rowData.full_slug}
                                    {/* <i className="pi pi-external-link" style={{ marginLeft: '2px', fontSize: '0.9rem' }}></i> */}
                                </a>
                            </strong>
                        )}
                    />
                    <Column field="departure.border" header="Departure Border" headerStyle={{ textAlign: 'center' }} />
                    <Column
                        header="Progress"
                        body={(rowData) => {
                            const percentage = rowData.completionPercentage || 0;
                            return (
                                <div className="flex align-items-center gap-2">
                                    <ProgressBar
                                        value={percentage}
                                        showValue={false}
                                        color={percentage === 100 ? '#22c55e' : percentage >= 70 ? '#3b82f6' : '#f59e0b'}
                                        style={{ width: '50px', height: '10px' }}
                                    />
                                    <span>{percentage}%</span>
                                </div>
                            );
                        }}
                    />
                    <Column
                        field="ports"
                        header="Crossing names"
                        headerStyle={{ textAlign: 'center' }}
                        body={(rowData) =>
                            rowData.crossing_names_section?.crossings_names?.length > 0
                                ? (
                                    <ul className='' style={{ margin: 0, paddingLeft: '1rem', textAlign: 'center' }}>
                                        {rowData?.crossing_names_section?.crossings_names?.length} crossing names
                                    </ul>
                                )
                                : <div className='flex align-items-center justify-content-center w-full'>
                                    <span className="pi pi-exclamation-triangle" style={{ color: 'orange' }}></span>
                                    <span className="ml-2 p-text-secondary p-text-sm">No crossing names</span>
                                </div>
                        }
                    />
                    <Column
                        header="Configure"
                        body={(rowData) => (
                            <>

                                <Button
                                    icon="pi pi-cog"
                                    className="p-button-text p-button-sm"
                                    onClick={() => navigate(`/entry_page/edit/${rowData._id}`)}
                                    tooltip="Edit entry page"
                                    tooltipOptions={{ position: 'top' }}
                                />
                            </>
                        )}
                        style={{ width: '6rem', textAlign: 'center' }}
                    />
                </DataTable>
            </div>
        </Card>
    );
}

